import { useEffect, useState } from "react";
import { Menu, Phone, X } from "lucide-react";

const links = [
  { label: "Work", href: "#showcase" },
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Reviews", href: "#reviews" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-black/70 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 flex items-center justify-between h-20">
        <a
          href="#top"
          data-testid="logo-link"
          className="flex items-center gap-2 group"
        >
          <span className="font-display text-[22px] tracking-tighter text-white">
            sonoran
          </span>
          <span className="font-mono-small text-[#E5D0A1] mt-1">/ az</span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm text-white/70 hover:text-white transition-colors u-link"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="tel:+14805550120"
            data-testid="navbar-phone-link"
            className="hidden sm:flex items-center gap-2 text-sm text-white/80 hover:text-[#E5D0A1] transition-colors"
          >
            <Phone className="w-4 h-4" strokeWidth={1.5} />
            <span className="font-body">(480) 555-0120</span>
          </a>
          <a
            href="#quote"
            data-testid="navbar-cta-button"
            className="hidden md:inline-flex bg-white text-black px-5 py-2.5 text-sm font-medium hover:bg-[#E5D0A1] transition-colors"
          >
            Free Quote
          </a>
          <button
            data-testid="navbar-menu-toggle"
            onClick={() => setOpen(!open)}
            className="md:hidden text-white p-2"
            aria-label="Toggle menu"
          >
            {open ? (
              <X className="w-5 h-5" strokeWidth={1.5} />
            ) : (
              <Menu className="w-5 h-5" strokeWidth={1.5} />
            )}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-500 bg-black/95 backdrop-blur-xl ${
          open ? "max-h-96 border-t border-white/5" : "max-h-0"
        }`}
      >
        <nav className="flex flex-col px-6 py-6 gap-4">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
              className="text-white/80 text-base py-2 border-b border-white/5"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#quote"
            onClick={() => setOpen(false)}
            data-testid="mobile-cta-button"
            className="mt-2 bg-white text-black px-5 py-3 text-center text-sm font-medium"
          >
            Get 30-Second Quote
          </a>
        </nav>
      </div>
    </header>
  );
}
